import { __rest } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { useColor } from '@10d/tend-ui-theme';
import { Root, Children, Svg, Circle } from './styled.js';
import styles from './Spinner.module.css.js';

const DIMENSIONS = {
    xs: 16,
    small: 32,
    medium: 48,
    large: 64,
};
const STROKE_WIDTH = {
    xs: 2,
    small: 3,
    medium: 4,
    large: 5,
};
const BaseSpinner = (_a, ref) => {
    var { loading = true, size = 'medium', color, children, className } = _a, rest = __rest(_a, ["loading", "size", "color", "children", "className"]);
    const dimensions = DIMENSIONS[size];
    const strokeWidth = STROKE_WIDTH[size];
    const radius = dimensions / 2 - strokeWidth;
    const xOffset = dimensions / 2;
    const yOffset = dimensions / 2;
    const strokeDashArray = Math.ceil(2 * Math.PI * radius);
    const strokeDashOffset = (strokeDashArray / 4) * 3;
    const isXs = size === 'xs';
    const isSmall = size === 'small';
    const isMedium = size === 'medium';
    const isLarge = size === 'large';
    const __color = useColor(color);
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-spinner' }, rest, { ref: ref, "$color": __color, className: cn([styles['tend-ui-spinner'], className], {
            [styles['tend-ui-spinner-loading']]: loading,
            [styles['tend-ui-spinner-size-xs']]: isXs,
            [styles['tend-ui-spinner-size-small']]: isSmall,
            [styles['tend-ui-spinner-size-medium']]: isMedium,
            [styles['tend-ui-spinner-size-large']]: isLarge,
        }) }),
        children && React.createElement(Children, { "$loading": loading }, children),
        loading && (React.createElement(Svg, { "$center": !!children, width: dimensions, height: dimensions },
            React.createElement(Circle, { fill: 'none', stroke: 'currentColor', strokeLinecap: 'round', strokeWidth: strokeWidth, strokeDasharray: strokeDashArray, strokeDashoffset: strokeDashOffset, r: radius, cx: xOffset, cy: yOffset })))));
};
const Spinner = React.forwardRef(BaseSpinner);
Spinner.displayName = 'Spinner';

export { Spinner };
